import { render, staticRenderFns } from "./adModal.vue?vue&type=template&id=60723061&"
import script from "./adModal.vue?vue&type=script&lang=js&"
export * from "./adModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports